<div class="emoji-picker-container shadow-lg rounded" (click)="$event.stopPropagation()">
  <!-- Header with Search -->
  <div class="picker-header p-3 pb-2 border-bottom border-secondary-subtle">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="mb-0 text-white fw-bold">Emojis</h6>
      <button type="button" class="btn-close btn-close-white btn-sm" (click)="closePicker.emit()" aria-label="Close" title="Close Emoji Picker"></button>
    </div>
    <div class="position-relative">
      <input type="text" class="form-control form-control-sm bg-black text-white border-secondary search-input"
             placeholder="Search emojis..." [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)">
      @if (searchQuery()) {
        <button type="button" class="btn btn-sm btn-link text-secondary position-absolute end-0 top-50 translate-middle-y me-1 border-0"
                (click)="searchQuery.set('')" title="Clear Search">
          <i class="bi bi-x-lg"></i>
        </button>
      }
    </div>
  </div>

  <!-- Categories Tabs (Only if not searching) -->
  @if (!searchQuery()) {
    <div class="picker-tabs d-flex justify-content-around px-2 py-1 border-bottom border-secondary bg-dark-subtle">
      @for (cat of categories; track cat.id) {
        <button type="button" class="btn btn-sm tab-btn border-0 text-secondary"
                [class.active]="activeCategoryId() === cat.id"
                (click)="activeCategoryId.set(cat.id)"
                [title]="cat.name">
          <span class="fs-5">{{ cat.icon }}</span>
        </button>
      }
    </div>
  }

  <!-- Emojis Grid -->
  <div class="emojis-grid-container p-3 overflow-auto">
    @if (searchQuery()) {
      <div class="search-results">
        <div class="small text-secondary mb-2 fw-semibold text-uppercase">Search Results ({{ filteredEmojis().length }})</div>
        <div class="emojis-grid">
          @for (emoji of filteredEmojis(); track emoji.char) {
            <button type="button" class="emoji-btn btn border-0 p-0 text-center"
                    (click)="select(emoji.char)"
                    (mouseenter)="hoveredEmoji.set(emoji)"
                    (mouseleave)="hoveredEmoji.set(null)">
              <span class="emoji-char">{{ emoji.char }}</span>
            </button>
          }
          @if (filteredEmojis().length === 0) {
            <div class="text-center text-muted py-5">
              <i class="bi bi-emoji-frown fs-2 d-block mb-2"></i>
              <span>No emojis found</span>
            </div>
          }
        </div>
      </div>
    } @else {
      @for (cat of categories; track cat.id) {
        @if (activeCategoryId() === cat.id) {
          <div class="category-section">
            <div class="small text-secondary mb-2 fw-semibold text-uppercase">{{ cat.name }}</div>
            <div class="emojis-grid">
              @for (emoji of cat.emojis; track emoji.char) {
                <button type="button" class="emoji-btn btn border-0 p-0 text-center"
                        (click)="select(emoji.char)"
                        (mouseenter)="hoveredEmoji.set(emoji)"
                        (mouseleave)="hoveredEmoji.set(null)">
                  <span class="emoji-char">{{ emoji.char }}</span>
                </button>
              }
            </div>
          </div>
        }
      }
    }
  </div>

  <!-- Footer displaying hovered emoji name -->
  <div class="picker-footer px-3 py-2 bg-black bg-opacity-50 text-truncate text-secondary border-top border-secondary-subtle d-flex align-items-center">
    @if (hoveredEmoji()) {
      <span class="text-white fs-5 me-2 lh-1">{{ hoveredEmoji()!.char }}</span>
      <span class="small font-monospace text-capitalize">:{{ hoveredEmoji()!.name }}:</span>
    } @else {
      <span class="small text-muted italic">Select an emoji...</span>
    }
  </div>
</div>
